import { useSelector } from 'react-redux';
import Error503 from '../pages/error/Error503';
import ErrorCheck from './Common/ErrorCheck';

const AuthenticatedComponent = ({ allowedRoles, children }: any) => {
    const { user } = useSelector((state: any) => state.user);
    // Check if user is authenticated and has the allowed role
    const isAuthenticated = user && allowedRoles.includes(user.user_role);

    return isAuthenticated ? <ErrorCheck>{children}</ErrorCheck> : <Error503 />;
};

export const IsAccessableComponent = ({ path, children, type }: any) => {
    const { user, permissions } = useSelector((state: any) => state?.user)

    if (path == '/auth/login' || path == '/') return <ErrorCheck>{children}</ErrorCheck>;
    if (user?.role == 'admin') return <ErrorCheck>{children}</ErrorCheck>;
    console.log(path)
    const isAuthenticated = user && permissions.includes('/' + path?.split('/')[1]);
    if (type == 'sidebar')
        return isAuthenticated ? <ErrorCheck>{children}</ErrorCheck> : <></>;
    else
        return isAuthenticated ? <ErrorCheck>{children}</ErrorCheck> : <Error503 />;

}



export default AuthenticatedComponent;
